import type { FooterNavItem, FooterSection, FooterSocialItem } from 'hermes-frontlib-ng-01-dsinterno';

const PUBLIC_SITE_BASE_URL = 'https://www.sabadellsegurosypensiones.com';
const EXTERNAL_TARGET = '_blank';
const INTERNAL_TARGET = '_self';

const publicSiteUrl = (path: string): string => `${PUBLIC_SITE_BASE_URL}${path}`;
const externalLink = (label: string, path: string): FooterNavItem => ({
    label,
    href: publicSiteUrl(path),
    target: EXTERNAL_TARGET
});

export const FOOTER_FAQS_LINK = publicSiteUrl('/es/ayuda/faqs');
export const CLIENT_AREA_FAQS_LINK = publicSiteUrl('/es/ayuda/faqs/faqs-area-cliente');
export const REGISTER_TERMS_LINK = publicSiteUrl('/es/legales/terminos-y-condiciones-area-cliente');
export const REGISTER_PRIVACY_LINK = publicSiteUrl('/es/legales/politica-de-privacidad');

export const FOOTER_SECTIONS: FooterSection[] = [
    {
        label: 'Particulares',
        href: publicSiteUrl('/es/particulares'),
        target: EXTERNAL_TARGET,
        items: [
            externalLink('Seguros de hogar', '/es/particulares/seguro-hogar'),
            externalLink('Seguros de salud', '/es/particulares/seguro-salud-y-dental'),
            externalLink('Seguros de coche', '/es/particulares/seguros-coche'),
            externalLink('Seguros de vida y accidentes', '/es/particulares/seguro-vida'),
            externalLink('Ahorro y pensiones', '/es/particulares/productos-de-ahorro'),
            externalLink('Seguros de decesos', '/es/particulares/decesos'),
            externalLink('Protección pagos', '/es/particulares/proteccion-pagos')
        ]
    },
    {
        label: 'Empresas y autónomos',
        href: publicSiteUrl('/es/empresas-y-autonomos'),
        target: EXTERNAL_TARGET,
        items: [
            externalLink('Seguros de comercios', '/es/empresas-y-autonomos/comercios'),
            externalLink('Seguros de vida para empresas', '/es/empresas-y-autonomos/vida'),
            externalLink('Ahorro y pensiones', '/es/empresas-y-autonomos/pensiones'),
            externalLink('Seguros de salud para empresas', '/es/empresas-y-autonomos/salud')
        ]
    },
    {
        label: 'Sobre nosotros',
        href: publicSiteUrl('/es/sobre-nosotros'),
        target: EXTERNAL_TARGET,
        items: [
            externalLink('Sostenibilidad', '/es/sobre-nosotros/sostenibilidad'),
            externalLink('Sala de prensa', '/es/sobre-nosotros/sala-de-prensa'),
            externalLink('Gobierno corporativo', '/es/sobre-nosotros/gobierno-corporativo'),
            externalLink('Cumplimiento normativo', '/es/sobre-nosotros/cumplimiento-normativo'),
            externalLink('Canal Ético', '/es/sobre-nosotros/canal-etico-proteccion-informante')
        ]
    },
    {
        label: 'Ayuda',
        href: publicSiteUrl('/es/ayuda'),
        target: EXTERNAL_TARGET,
        items: [
            { ...externalLink('Faqs', '/es/ayuda/faqs'), href: FOOTER_FAQS_LINK },
            externalLink('Blog', '/es/ayuda/blog'),
            externalLink('Contacto', '/es/ayuda/contacto'),
            externalLink('Quejas y reclamaciones', '/es/ayuda/quejas-y-reclamaciones')
        ]
    }
];

export const FOOTER_LEGAL_LINKS: FooterNavItem[] = [
    { label: 'Aviso legal', href: publicSiteUrl('/es/legales/aviso-legal'), target: INTERNAL_TARGET },
    { label: 'Términos y condiciones', href: publicSiteUrl('/es/legales/terminos-y-condiciones-de-uso'), target: INTERNAL_TARGET },
    { label: 'Uso de cookies', href: publicSiteUrl('/es/legales/gestion-de-cookies'), target: INTERNAL_TARGET },
    { label: 'Accesibilidad', href: publicSiteUrl('/es/legales/accesibilidad'), target: INTERNAL_TARGET },
    {
        label: 'Información sobre el tratamiento de datos personales',
        href: publicSiteUrl('/es/legales/politica-de-privacidad'),
        target: INTERNAL_TARGET
    }
];

export const FOOTER_SOCIAL_LINKS: FooterSocialItem[] = [];
